import React, { useState } from 'react';
import { useExamSessionStore } from '../../stores/StoreContext';
import {
    IconButton,
    IconInfoLine,
    Popover,
    View,
    Flex,
    Text,
    List,
} from '@smarterservices/smarter-ui';
import LabelAndText from '../Common/LabelAndText';
import CONSTANTS from '../../config/constants';
const NameInfo = () => {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);

    const firstName = useExamSessionStore((state) => state.userData.firstName);
    const lastName = useExamSessionStore((state) => state.userData.lastName);
    const email = useExamSessionStore((state) => state.userData.email);
    const phone = useExamSessionStore((state) => state.userData.mobilePhone);
    const timezone = useExamSessionStore((state) => state.userData.timezone?.name);

    const courseTitle = useExamSessionStore((state) => state.courseData.title);
    const instructorFirstName = useExamSessionStore((state) => state.courseData.instructor?.firstName);
    const instructorLastName = useExamSessionStore((state) => state.courseData.instructor?.lastName);
    const accountName = useExamSessionStore((state) => state.sessionData?.account?.name);

    return (
        <Popover
            isShowingContent={isPopoverOpen}
            onShowContent={() => setIsPopoverOpen(true)}
            onHideContent={() => setIsPopoverOpen(false)}
            on="click"
            offsetX={5}
            screenReaderLabel="Session information"
            shouldContainFocus
            shouldReturnFocus
            shouldCloseOnDocumentClick
            renderTrigger={() => (
                <IconButton
                    screenReaderLabel="Show session information"
                    size="small"
                    withBackground={false}
                    withBorder={false}
                >
                    <IconInfoLine size="x-small" />
                </IconButton>
            )}>

            <View as="div" padding="small" minWidth="500px">
                <Flex gap="medium" alignItems="start">
                    <Flex.Item shouldGrow shouldShrink>
                        <View as="div" margin="none none x-small none">
                            <Text weight="bold" size="medium">User Information</Text>
                        </View>
                        <List
                            margin="none"
                            isUnstyled
                            itemSpacing={CONSTANTS.STYLES.CARD_ITEM_SPACING}
                        >
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Name" text={`${firstName} ${lastName}`} />
                            </List.Item>
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Email" text={email || 'N/A'} />
                            </List.Item>
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Phone" text={phone || 'N/A'} />
                            </List.Item>
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Timezone" text={timezone || 'N/A'} />
                            </List.Item>
                        </List>
                    </Flex.Item>

                    <Flex.Item>
                        <View
                            as="div"
                            borderWidth="none small none none"
                            borderColor="secondary"
                            height="100%"
                            minHeight="130px"
                        />
                    </Flex.Item>

                    <Flex.Item shouldGrow shouldShrink>
                        <View as="div" margin="none none x-small none">
                            <Text weight="bold" size="medium">Course Information</Text>
                        </View>
                        <List
                            margin="none"
                            isUnstyled
                            itemSpacing={CONSTANTS.STYLES.CARD_ITEM_SPACING}
                        >
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Account" text={accountName || 'N/A'} />
                            </List.Item>
                            <List.Item>
                                <LabelAndText labelWidth="70px" label="Course" text={courseTitle || 'N/A'} />
                            </List.Item>
                            <List.Item>
                                <LabelAndText
                                    labelWidth="70px"
                                    label="Instructor"
                                    text={instructorFirstName && instructorLastName
                                        ? `${instructorFirstName} ${instructorLastName}`
                                        : 'N/A'}
                                />
                            </List.Item>
                        </List>
                    </Flex.Item>
                </Flex>
            </View>

        </Popover>
    );
};

export default NameInfo;